export default __webpack_public_path__ + "static/media/instagram-reels.c7bd5df3.jpg";